import { colors } from "./colors";

export var defaultTheme = {
  _themeVersion: 0.5,
  width: "73em", // old: "1000px"
  fontFamily: "\"Gilroy\", sans-serif",
  fontSize: "16px",

  colors: colors,

  globalSitePadding: [1, 1, 2, 2],

  softCornerRadius: 1.5,

  buttonBorderRadius: 0,
  buttonDefaultHeight: 3.5,
  buttonCompactHeight: 2.5,

  typoTextAlign: null,

  primary: colors.coreNavy,
  primaryDark: colors.darkNavy,
  primaryLight: colors.lightNavy,

  secondary: colors.corePink,
  secondaryLight: colors.lightPink,

  dangerMedium: colors.brickRed,
  dangerLight: colors.porcelainPink,
  warningMedium: colors.marigoldYellow,
  warningLight: colors.paperYellow,
  successMedium: colors.spruceGreen,
  successLight: colors.slimlimeGreen,
  neutralMedium: "rgba(0, 0, 0, 0.35)",
  neutralLight: colors.edgarWhite,

  textMedium: colors.coreGrey,
  textStrong: colors.darkGrey,
  textSoft: "rgba(0, 0, 0, 0.35)",
  textNegative: colors.coreWhite,

  formFocusColor: colors.paleNavy,
  formBorderColor: "rgba(0, 0, 0, 0.2)",

  background: colors.white,

  navBg: colors.white,
  navPrimary: colors.coreNavy,

  altThemes: {
    inverted: {
      background: colors.darkNavy,
      primary: colors.white,
      primaryDark: colors.white,
      textMedium: colors.white,
      textStrong: colors.white,
      textNegative: colors.black
    }
  },

  // Use this moving forward
  breakpointsRaw: [480, 768, 1024],

  // Legacy from Reflexbox, want to switch the naming at some point but need a breaking change in web
  breakpoints: [480 / 16 + "em", 768 / 16 + "em", 1024 / 16 + "em"],

  breakpointsNew: {
    // temp, remove after non-breaking
    desktop: 768
  },

  boxShadow: {
    medium: "0 1px 10px 0px rgba(0,0,0,0.08)",
    strong: "0 1px 10px 0px rgba(0,0,0,0.16)"
  },
  transitions: {
    easeInOut: "cubic-bezier(0.69, 0, 0.33, 0.99)"
  }
};